import { Tender } from "../tender.module";
import Modal from "../../../common/components/Modal";
import { PrimaryButton } from "../../../common/components/CustomButton";
import { Dispatch, SetStateAction } from "react";

const ExtruderErrorModal = ({
    tender, isDialogOpen, onClose
}: {
    tender: Partial<Tender> | Tender; isDialogOpen: boolean; onClose: Dispatch<SetStateAction<boolean>>
}) => {
    return (
        <Modal
            title="Extruder response"
            onClose={() => onClose(false)}
            open={isDialogOpen}
            actions={
                <PrimaryButton
                    onClick={() => onClose(false)}
                    text="Close"
                    type="button"
                    color="primary"
                />
            }
            maxWidth="xl"
        >
            <pre>{ JSON.stringify(tender.latest_extruder_submission?.response, null, 2) }</pre>
        </Modal>
    );
};

export default ExtruderErrorModal;
